export default "https://shopfront-cdn.tekoapis.com/_next/static/images/product-no-rating-0e8d9f3c324bf25bf643ac795de27ba4.svg";